interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "ink" | "light";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "ink",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const isLight = tone === "light";

  return (
    <div className={`${isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}`}>
      {eyebrow ? (
        <span
          className={`mb-3 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.22em] ${
            isLight ? "text-accent-300" : "text-primary-600"
          }`}
        >
          <span className={`h-px w-6 ${isLight ? "bg-accent-400" : "bg-primary-500"}`} />
          {eyebrow}
        </span>
      ) : null}
      <h2
        className={`text-2xl font-bold leading-snug md:text-[2rem] ${
          isLight ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description ? (
        <p
          className={`mt-3 text-sm leading-relaxed md:text-[15px] ${
            isLight ? "text-background-200/90" : "text-foreground-600"
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}